import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import queryString from 'query-string';
import classNames from 'classnames/bind';
import logo from 'assets/images/crm-logo.png';
import styles from '../index.less';

const cx = classNames.bind(styles);

const HasBeenReset = ({ location }) => {
  const { search } = location;
  const { username } = queryString.parse(search);

  return (
    <div className={cx('reset-success-wrapper')}>
      <div className={cx('reset-container')}>
        <img src={logo} alt="logo" />
        <div className={cx('reset-content')}>
          <FormattedMessage id="page.Auth.passwordHasbeenReset">
            {text => <span className={cx('title')}>{text}</span>}
          </FormattedMessage>
          <div className={cx('content-text')}>
            <FormattedMessage id="page.Auth.hi" values={{ username }} tagName="p" />
            <FormattedMessage id="page.Auth.firstContent" tagName="p" />
            <Link to="/auth/login">
              <Button className={cx('login-btn')}>
                <FormattedMessage id="page.Auth.loginToSandbox" />
              </Button>
            </Link>
            <FormattedMessage id="page.Auth.secondContent">
              {text => <p className={cx('content-second')}>{text}</p>}
            </FormattedMessage>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(HasBeenReset);



// WEBPACK FOOTER //
// ./src/views/Auth/HasBeenRest/container/index.jsx